/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Biaya_S1Inputs */

const en_mk_tut_biaya_s1 = /** @type {(inputs: Mk_Tut_Biaya_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Analytics** to see cost per agent and per run for the current month.`)
};

const id_mk_tut_biaya_s1 = /** @type {(inputs: Mk_Tut_Biaya_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka menu **Analytics** untuk melihat biaya per agen dan per run bulan berjalan.`)
};

/**
* | output |
* | --- |
* | "Open **Analytics** to see cost per agent and per run for the current month." |
*
* @param {Mk_Tut_Biaya_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_biaya_s1 = /** @type {((inputs?: Mk_Tut_Biaya_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Biaya_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_biaya_s1(inputs)
	return en_mk_tut_biaya_s1(inputs)
});